import React, { Component } from "react";
import { FaIdCard, FaHiking, FaShuttleVan } from "react-icons/fa";
import Title from "./Title";
export default class Services extends Component {
  state = {
    services: [
      {
        icon: <FaIdCard />,
        title: "What We Do",
        info:
          "We are a prominent manufacturer of a high-quality range of Outdoor Multi Play Station, Playground Slides, Playground Equipment’s, Sanitation Products, Open Gym Equipments and many more. We supply the equipment’s pan India."
      },
      {
        icon: <FaHiking />,
        title: "Our Approach",
        info:
          "We take an inclusive approach to help our clients succeed, by providing them with effective equipment’s. We make sure our clients get happy and maintain longevity relations with us."
      },
      {
        icon: <FaShuttleVan />,
        title: "Our Mission",
        info:
          "Our products should be effective for the entire individual.  We want to make our presence globally and become one of the best outdoor green gym equipment suppliers."
      }
    ]
  };
  render() {
    return (
      <section className="services">
        <Title title="About Us" />
        <div className="services-center">
          {this.state.services.map(item => {
            return (
              <article key={`item-${item.title}`} className="service">
                <span>{item.icon}</span>
                <h6>{item.title}</h6>
                <p>{item.info}</p>
              </article>
            );
          })}
        </div>
      </section>
    );
  }
}
